// extracted by mini-css-extract-plugin
export default {"LoadingCom":"loadingCom_LoadingCom__EvXRH"};